import { forwardRef, type ReactNode } from "react";

interface BottomBarShellProps {
  children: ReactNode;
  onBackgroundClick?: () => void;
}

export const BottomBarShell = forwardRef<HTMLDivElement, BottomBarShellProps>(
  ({ children, onBackgroundClick }, ref) => {
    return (
      <div
        ref={ref}
        data-layout="bottombar"
        className="border-t border-slate-300 bg-[#eaeef1] shadow-lg"
        onClick={(event) => {
          if (event.target === event.currentTarget) {
            onBackgroundClick?.();
          }
        }}
      >
        {children}
      </div>
    );
  },
);

BottomBarShell.displayName = "BottomBarShell";
